import type { BaseEntity } from '../base';

export const getDocumentOrder = (document: BaseEntity, parentDocument: BaseEntity) => {
  const { childrenIds } = parentDocument.meta;

  return childrenIds ? childrenIds.indexOf(document._id) : -1;
};
